import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany } from 'auth/selectors';
import * as Exchange from 'exchange/components';

class ExchangeRowContainer extends Component {
  render = () => (
    <Exchange.Row
      exchange={this.props.exchange}
      company={this.props.company}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  permissions: getPermissions(state),
  company: getCompany(state),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/containers/ExchangeRowContainer.js